import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useNetworkStore } from "@/stores/network-store";

export const useNetworkApplicantsInvitedFeedStore = defineSmartFeedPiniaStore(
  "network-applicants-invited-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      feedUrl: `/network/${useNetworkStore().networkId}/applicants`,
      defaultFilterValues: {
        status: { key: "status", payload: "invited" },
        networkId: {
          "key": "network_id",
          "payload": useNetworkStore().networkId,
        },
      },
      tableFields: [
        { key: "publicationName", label: "Publication" },
        { key: "status", label: "Status" },
      ],
    }),
  },
);
